<body data-spy="scroll" data-target=".fixed-top">
<app-public-navbar></app-public-navbar>
    <!-- <nav class="navbar navbar-expand-lg fixed-top navbar-light">
        <div class="container"> -->

            <!-- Text Logo - Use this if you don't have a graphic logo -->
            <!-- <a class="navbar-brand logo-text page-scroll" href="index.html">Kora</a> -->

            <!-- Image Logo -->
            <!-- <a class="navbar-brand logo-image" href="">
                <img src="assets/images/xchange.png" alt="alternative"></a>

            <button class="navbar-toggler p-0 border-0" type="button" data-target="#navbarsExampleDefault"
                aria-controls="navbarsExampleDefault" aria-expanded="true" aria-label="toggle navigation"
                data-toggle="collapse">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse1" id="navbarsExampleDefault">
                <ul class="navbar-nav ml-auto">
                    <li class="nav-item">
                        <a class="nav-link page-scroll" routerLink="/">Home <span class="sr-only">(current)</span></a>
                    </li>

                    <li class="nav-item">
                        <a routerLink="/intro" class="nav-link page-scroll" (click)="gotoScroll('intro')">Intro</a>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/howItWorks" class="nav-link page-scroll" (click)="gotoScroll('details')">How it
                            Works</a>
                    </li>
                    <li class="nav-item">
                        <a routerLink="/features" class="nav-link page-scroll"
                            (click)="gotoScroll('features')">Features</a>
                    </li>

                    <li class="nav-item" *ngIf="!user">
                        <a routerLink="/contact-us" class="nav-link page-scroll" href="javascript:void(0)">Contact Us
                        </a>
                    </li>
                    <li class="nav-item" *ngIf="!user">
                        <a routerLink="/faqs" class="nav-link page-scroll" href="javascript:void(0)">FAQ's</a>
                    </li> -->
                    <!-- <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="dropdown01" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">Drop</a>
                        <div class="dropdown-menu" aria-labelledby="dropdown01">
                            <a class="dropdown-item page-scroll" href="article.html">Article Details</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item page-scroll" href="terms.html">Terms Conditions</a>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item page-scroll" href="privacy.html">Privacy Policy</a>
                        </div>
                    </li>  -->
                    <!-- <li class="nav-item" *ngIf="this.extra">
                        <a routerLink="/account/register-email" class="btn-solid-sm page-scroll" href="">Signup</a>
                        <a routerLink="/account/login" class="btn-solid-sm page-scroll" href="">Login</a>
                    </li>
                    <li class="nav-item" *ngIf="!this.extra">
                        <a routerLink="" class="btn-solid-sm page-scroll" (click)="dashboard()">Go to Content List</a>
                        <a routerLink="/account/login" class="btn-solid-sm page-scroll" (click)="logout()">Logout</a>
                    </li>
                </ul> -->

                <!-- <span class="nav-item" *ngIf="user">
                    <a routerLink="/{{ (user.type == 1) ? 'buyer' : 'seller'}}" class="btn-solid-sm page-scroll" href="">Dashboard</a>
                </span> -->
            <!-- </div> end of navbar-collapse -->
        <!-- </div> end of container -->
    <!-- </nav> -->

    <div class="feature-container">
        <div class="top-container">
            <img src="assets/newImages/feature.png" alt="" style="width: 100%;">
            <div class="heading-container">
                <h1>How It <span class="gradient-text">Works</span></h1>
                <p>Start your journey in the content licensing marketplace in just a few simple steps.</p>
                <div class="btn-container">
                    <!-- <button class="btn1" ><a routerLink="/contact-us"> Request a demo</a></button> -->
                    <button class="btn1" routerLink="/contact-us"> Request a demo</button>

                    <!-- <button class="btn1">Show Library</button>
                <button class="btn2">Join Connekkt Xchange</button> -->
                </div>
            </div>
        </div>
    </div>
    <div class="bottom-container">
        <!-- <div class="box-container"> -->
            <!-- <div class="box1">
            <div class="step-number">
<img src="assets/newImages/step1.png" alt="">
            </div>
            <div class="content">
<h3>Create & host content</h3>
<p>Your content on paid Connekkt account</p>
            </div>
            <div class="contentImg">
<img src="assets/newImages/host-manage.png" alt="">
            </div>
        <div class="arrow"><img src="assets/newImages/curve-arrow.png" alt=""></div>

        </div>
          <div class="box2">
            <div class="step-number">
<img src="assets/newImages/step2.png" alt="">
            </div>
            <div class="content">
<h3>Drive Sales , Enable Smart Search
& Negotiate</h3>
<p>To sell your content to buyers across the globe</p>
<p>by adding meta-descriptions, content categories, regions, and more.</p>
<p>with buyers and sellers via chat, video audio conference, Slack and more, with 100% record keeping option for workflows & conversations for audit & transparency.</p>
            </div>
            <div class="contentImg">
<img src="assets/newImages/step2Img.png" alt="">
                
            </div>

        <div class="arrow">
            <img src="assets/newImages/curve-arrow.png" alt="">
        </div>

        </div>
          <div class="box3">
            <div class="step-number">
<img src="assets/newImages/step3.png" alt="">

            </div>
            <div class="content">

            </div>
            <div class="contentImg">
                
            </div>
        </div> -->


            <div class="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
                <div class="relative group">
                    <div
                        class="hidden lg:block absolute top-16 left-[60%] w-full h-px bg-gradient-to-r from-border via-primary/30 to-border">
                        
                    </div>
                    <div class="glass-card rounded-2xl p-8 h-full hover-lift"><span
                            class="font-display text-5xl font-bold text-primary/20 mb-4 block">01</span>
                        <div
                           class="w-14 h-14 rounded-xl flex items-center justify-center mb-6 icon-bg group-hover:animate-pulse-glow transition-all">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-user-plus text-primary-foreground">
                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                                <circle cx="9" cy="7" r="4"></circle>
                                <line x1="19" x2="19" y1="8" y2="14"></line>
                                <line x1="22" x2="16" y1="11" y2="11"></line>
                            </svg></div>
                        <h3 class="font-display font-semibold text-xl mb-3">Create Your Account</h3>
                        <p class="text-muted-foreground text-sm leading-relaxed">Sign up for free and set up your
                            profile. Whether you're a content creator or a buyer, get started in minutes.</p>
                    </div>
                </div>
                <div class="relative group">
                    <div
                        class="hidden lg:block absolute top-16 left-[60%] w-full h-px bg-gradient-to-r from-border via-primary/30 to-border">
                    </div>
                    <div class="glass-card rounded-2xl p-8 h-full hover-lift"><span
                            class="font-display text-5xl font-bold text-primary/20 mb-4 block">02</span>
                       <div
                           class="w-14 h-14 rounded-xl flex items-center justify-center mb-6 icon-bg group-hover:animate-pulse-glow transition-all">
                              <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-folder-up text-primary-foreground">
                                <path
                                    d="M20 20a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.9a2 2 0 0 1-1.69-.9L9.6 3.9A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13a2 2 0 0 0 2 2Z">
                                </path>
                                <path d="M12 10v6"></path>
                                <path d="m9 13 3-3 3 3"></path>
                            </svg></div>
                        <h3 class="font-display font-semibold text-xl mb-3">List Your Content</h3>
                        <p class="text-muted-foreground text-sm leading-relaxed">Upload your media content with detailed
                            metadata. Add categories, regions, cast info, and set your pricing.</p>
                    </div>
                </div>
                <div class="relative group">
                    <div
                        class="hidden lg:block absolute top-16 left-[60%] w-full h-px bg-gradient-to-r from-border via-primary/30 to-border">
                    </div>
                    <div class="glass-card rounded-2xl p-8 h-full hover-lift"><span
                            class="font-display text-5xl font-bold text-primary/20 mb-4 block">03</span>
                       <div
                           class="w-14 h-14 rounded-xl flex items-center justify-center mb-6 icon-bg group-hover:animate-pulse-glow transition-all">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-handshake text-primary-foreground">
                                <path d="m11 17 2 2a1 1 0 1 0 3-3"></path>
                                <path
                                    d="m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4">
                                </path>
                                <path d="m21 3 1 11h-2"></path>
                                <path d="M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3"></path>
                                <path d="M3 4h8"></path>
                            </svg></div>
                        <h3 class="font-display font-semibold text-xl mb-3">Negotiate &amp; Contract</h3>
                        <p class="text-muted-foreground text-sm leading-relaxed">Connect with buyers through chat, video
                            calls, or Slack. Use smart contracts and predefined templates.</p>
                    </div>
                </div>
                <div class="relative group">
                    <div class="glass-card rounded-2xl p-8 h-full hover-lift"><span
                            class="font-display text-5xl font-bold text-primary/20 mb-4 block">04</span>
                       <div
                           class="w-14 h-14 rounded-xl flex items-center justify-center mb-6 icon-bg  group-hover:animate-pulse-glow transition-all">
                                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-badge-check text-primary-foreground">
                                <path
                                    d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z">
                                </path>
                                <path d="m9 12 2 2 4-4"></path>
                            </svg></div>
                        <h3 class="font-display font-semibold text-xl mb-3">Secure Transaction</h3>
                        <p class="text-muted-foreground text-sm leading-relaxed">Complete the deal with escrow-protected
                            payments. Content links are exchanged only after payment confirmation.</p>
                    </div>
                </div>
            </div>

        <!-- </div> -->
         <!-- <h2>To learn more,Play the video</h2>
<div id="player" class="video-wrapper"></div> -->
    </div>
    <div id="video-section" class="bottom-container2">
           <h2>To learn more, play the video.</h2>
<div id="player" class="video-wrapper"></div>
    </div>
    <div class="footer">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="footer-col first">
                        <h6>About Connekkt Xchange</h6>
                        <p class="p-small">Connekkt Xchange is a next‑generation B2B content marketplace that enables
                            publishers, studios, platforms, and distributors to seamlessly discover, license,
                            distribute, and monetize content across global markets.
                        </p>
                    </div> <!-- end of footer-col -->
                    <div class="footer-col second">
                        <h6>Useful Links</h6>
                        <ul class="list-unstyled li-space-lg p-small">
                            <li><a href="/terms&conditions">Terms & Conditions</a><br /> <a
                                    routerLink="/privacy-policy">Privacy
                                    Policy</a> <br><a routerLink="/faqs">FAQs</a> <br><a
                                    routerLink="/privacySettings">Cookie Preferences</a>
                                <br><a routerLink="/contact-us">Contact Us</a>
                            </li>
                            <!-- <li>Useful: <a href="#">Colorpicker</a>, <a href="#">Icon Library</a>, <a
                                    href="#">Illustrations</a></li>
                            <li>Menu: <a class="page-scroll" href="#header">Home</a>, <a class="page-scroll"
                                    href="#intro">Intro</a>, <a class="page-scroll" href="#features">Features</a>, <a
                                    class="page-scroll" href="#details">Details</a></li> -->

                        </ul>
                    </div> <!-- end of footer-col -->
                    <div class="footer-col third">
                        <span class="fa-stack">
                            <a href="#your-link">
                                <!-- <i class="fas fa-circle fa-stack-2x"></i> -->
                                <!-- <i class="fab fa-facebook-f fa-stack-1x"></i> -->
                                <img class="footer-img" src="assets/newImages/twitter.png" alt="">
                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/facebook.png" alt="">
                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-twitter fa-stack-1x"></i> -->
                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/instagram.png" alt="">

                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-pinterest-p fa-stack-1x"></i> -->
                            </a>
                        </span>
                        <span class="fa-stack">
                            <a href="#your-link">
                                <img class="footer-img" src="assets/newImages/pinterest.png" alt="">

                                <!-- <i class="fas fa-circle fa-stack-2x"></i>
                                <i class="fab fa-instagram fa-stack-1x"></i> -->
                            </a>
                        </span>
                        <p class="p-small">We would love to hear from you <a
                                href="mailto:support@connekktxchange.com"><strong>support@connekktxchange.com</strong></a>
                            <!-- <br />
                            <a href="tel:+4407466 31893"><strong>+44 07466 331893</strong></a> -->
                        </p>

                    </div> <!-- end of footer-col -->
                </div> <!-- end of col -->
            </div> <!-- end of row -->

            <!-- Copyright -->
            <div class="copyright">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <p class="p-small">Copyright © <a href="#your-link">Connekkt Xchange</a></p>
                        </div> <!-- end of col -->
                    </div> <!-- enf of row -->
                </div> <!-- end of container -->
            </div> <!-- end of copyright -->

        </div> <!-- end of container -->
    </div>
</body>